import type { Service } from "@/hooks/useSiteContent";

interface ServiceStepProps {
  services: Service[];
  selectedServiceId: string;
  onSelect: (serviceId: string) => void;
}

export default function ServiceStep({
  services,
  selectedServiceId,
  onSelect,
}: ServiceStepProps) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
      {services.map((service) => {
        const isSelected = selectedServiceId === service.id;
        return (
          <button
            key={service.id}
            type="button"
            onClick={() => onSelect(service.id)}
            className={`text-left rounded-lg border-2 p-4 md:p-5 transition-all cursor-pointer ${
              isSelected
                ? "border-primary-500 bg-primary-50"
                : "border-background-200/70 bg-background-50 hover:border-primary-300"
            }`}
          >
            <div className="flex items-start gap-3">
              <div className="w-14 h-14 md:w-16 md:h-16 flex-shrink-0 rounded-lg overflow-hidden">
                <img
                  src={service.image}
                  alt={service.name}
                  title={`${service.name} - dịch vụ chăm sóc sức khỏe`}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="font-display text-base md:text-lg font-semibold text-foreground-950 leading-snug">
                  {service.shortName}
                </h3>
                <p className="text-xs text-foreground-500 font-label mt-0.5">
                  {service.duration}
                </p>
                <div className="flex items-center gap-2 mt-2 flex-wrap">
                  <span className="text-sm line-through text-foreground-400 font-label">
                    {service.price.toLocaleString("vi-VN")}đ
                  </span>
                  <span className="text-sm font-semibold text-primary-700 font-label">
                    {service.promoPrice.toLocaleString("vi-VN")}đ
                  </span>
                </div>
              </div>
              <div
                className={`w-5 h-5 flex-shrink-0 flex items-center justify-center rounded-full border-2 mt-1 ${
                  isSelected
                    ? "border-primary-500 bg-primary-500 text-background-50"
                    : "border-background-300 text-transparent"
                }`}
              >
                <i className="ri-check-line text-xs" />
              </div>
            </div>
          </button>
        );
      })}
    </div>
  );
}